// Simple client-side translator with localStorage cache.
// Uses LibreTranslate-compatible API. Configure REACT_APP_TRANSLATE_URL to override endpoint.

// Default to backend proxy to avoid CORS/rate limits; can be overridden
const DEFAULT_ENDPOINT = (process.env.REACT_APP_TRANSLATE_URL as string) || '/api/utils/translate';

function getCacheKey(text: string, from: string, to: string): string {
  return `i18n-trans:${from}->${to}:${text}`;
}

export async function translateWithCache(
  text: string,
  from: 'es' | 'en',
  to: 'es' | 'en'
): Promise<string> {
  if (!text || from === to) return Promise.resolve(text);

  try {
    const key = getCacheKey(text, from, to);
    const cached = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    if (cached) {
      console.log(`[Translation Cache] Using cached translation for "${text}": "${cached}"`);
      return cached;
    }

    console.log(`[Translation API] Translating "${text}" from ${from} to ${to}`);
    const endpoint = DEFAULT_ENDPOINT;
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ q: text, source: from, target: to, format: 'text' }),
    });

    console.log(`[Translation API] Response status: ${res.status}`);

    if (!res.ok) {
      console.error(`[Translation API] Failed to translate "${text}": ${res.status} ${res.statusText}`);
      return text;
    }

    const data = await res.json();
    const translated: string = data?.translatedText || text;

    console.log(`[Translation API] Translation result for "${text}": "${translated}"`);

    if (typeof window !== 'undefined') localStorage.setItem(key, translated);
    return translated;
  } catch (error) {
    console.error(`[Translation API] Error translating "${text}":`, error);
    return text;
  }
}


